import {
  useAdvanceTableDataBrowseContext,
  useAdvanceTableTableContext,
} from '@aibees/shared/features';
import { memo } from 'react';
import type { SxStyle } from '@aibees/shared/theme';
import { SearchTableHeader } from './search-table-header';
import type { SearchTableHeaderActionsProps } from './types';

interface SearchTableHeaderWithContextProps
  extends Pick<SearchTableHeaderActionsProps, 'children' | 'extraActions'> {
  sx?: SxStyle;
  isSmall?: boolean;
}

/**
 * Renders SearchTableHeader with table and data from AdvanceTable context.
 * Used with config.renderTablePrependStable so the prepend element identity
 * does not depend on data/table/filters; header only re-renders when
 * context actually changes instead of on every Table re-render.
 */
export const SearchTableHeaderWithContext = memo(
  function SearchTableHeaderWithContext({
    sx,
    children,
    extraActions,
    isSmall,
  }: SearchTableHeaderWithContextProps) {
    const { table } = useAdvanceTableTableContext();
    const { browseData } = useAdvanceTableDataBrowseContext();
    const data = browseData?.data;

    return (
      <SearchTableHeader
        sx={sx}
        table={table}
        data={data}
        isSmall={isSmall}
        extraActions={extraActions}
      >
        {children}
      </SearchTableHeader>
    );
  }
);
